import { RoleScope } from "@organizations/models";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { HealthUser } from "@app/core/models/health-user.state";

export interface RoleAssignment {
  id: string;
  roleName: string;
  roleDisplayName: string;
  scope: RoleScope;
  assignee: HealthUser;
  // Following only for display purposes
  organizationId: string;
  organizationName: string;
  locationId: string | undefined;
  locationName: string | undefined;
  ouId: string | undefined;
  organizationalUnitName: string | undefined;
}

export interface RoleAssignmentState extends EntityState<RoleAssignment> {
  loading: boolean;
  loaded: boolean;
}

export const roleAssignmentAdapter: EntityAdapter<RoleAssignment> =
  createEntityAdapter<RoleAssignment>({
    selectId: (roleAssignment: RoleAssignment) => roleAssignment.id,
    sortComparer: (roleAssignment1, roleAssignment2) =>
      roleAssignment1.roleName.localeCompare(roleAssignment2.roleName)
  });
